export const AI_SEARCH_STEPS = ['tripInfo', 'hotels', 'restaurants', 'locations', 'activities'];

export const createEmptyAiSearchProgress = () => ({
  tripInfo: 'pending',
  hotels: 'pending',
  restaurants: 'pending',
  locations: 'pending',
  activities: 'pending',
  counts: {}
});
